import { Component, Input } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { CaseService } from '../../services/case.service';
import { ProcessEnum, SharedHttpService } from '../../services/shared-http.service';
import { DomSanitizer } from '@angular/platform-browser';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Role } from '../../services/role.service';

@Component({
  selector: 'app-addition-request',
  templateUrl: './addition-request.component.html',
  styleUrl: './addition-request.component.scss'
})
export class AdditionRequestComponent {

  public loadfromparent = new BehaviorSubject<any>('');
  public loadfromparent2 = new BehaviorSubject<any>('');
  public loadfromparent3 = new BehaviorSubject<any>('');
  public loadfromparent4 = new BehaviorSubject<any>('');
  showAddPage : Boolean = false;
  showEditPage : Boolean = false;


  @Input() eCaseId:any;
  caseId: any;
  additionRequestId:any;
  title:any;
  branchProsecutionArr:any=[];
  prosecuationId:any;
  description:any;

  AttachShow:boolean=false;
  hasAttachment:boolean=true;
  additionRequestArr:any=[];
  editedAdditionRequest:any;
  caseDetails:any;
  lengthAttach: any;

  attachmentList:any=[];

  public Process = ProcessEnum;
  public RoleEnum = Role;
  
  constructor(private caseService: CaseService,public sharedService : SharedHttpService,private modalService: NgbModal,private sanitizer: DomSanitizer,) { }
  

  ngOnInit(): void {
    this.caseId = this.caseService.case.caseId;
    this.caseDetails=this.caseService.case;
    this.sharedService.get(`api/Branch/GetBranchProsecutionLookup?BranchId=${this.caseDetails.branchId}`).subscribe(res=>{
      this.branchProsecutionArr=res;
    });
    this.loadData();
  }
  loadData(){
    this.sharedService.get(`api/AdditionRequest/GetAdditionRequests?eCaseId=${this.eCaseId}`).subscribe(res=>{
      this.additionRequestArr = res;
    })
  }
  additionRequestAttachment(id, model) {
    this.sharedService.openLarge(model);
    this.loadfromparent.next({ "id": id, "IsReadOnly": false });
  }

  openCreateModal(){
    this.additionRequestId = undefined;
    this.prosecuationId=undefined
    this.AttachShow=false;
    this.hasAttachment=true;
    this.title=undefined;
    this.description=undefined;
    // this.sharedService.openLarge(modal);
    this.showAddPage=true;
  }
  addAdditionRequest(){
    let obj = {
      "additionRequestId": this.additionRequestId,
      "caseId": this.caseId,
      "title": this.title,
      "description": this.description,
      "prosecutionId":this.prosecuationId,
      "isDeleted": false
    }
    if(this.additionRequestId){
      this.sharedService.put(`api/AdditionRequest/Update`, [obj]).subscribe(res => {
        this.loadData();
        this.sharedService.showSuccessKey("EditedSuccessfully");
      });
    }else{
      this.sharedService.post(`api/AdditionRequest/Insert`,[obj]).subscribe(res=>{
        this.AttachShow=true;
        this.hasAttachment=false;
        this.additionRequestId=res[0].additionRequestId;
        this.sharedService.showSuccessKey("AdditionRequestAddedSuccessfully");
          this.loadData();
          this.loadfromparent2.next({ "id": res[0].additionRequestId, "IsReadOnly": false });
      });

    }
  }
  deleteAdditionRequest(additionRequestId: any, mymodal) {
    this.sharedService.openSmall(mymodal);
    this.additionRequestId = additionRequestId;
  }
  onDeleteAdditionRequest(modal){
    this.sharedService.delete(`api/AdditionRequest/Delete`, [this.additionRequestId]).subscribe((response) => {
      this.loadData();
      this.additionRequestId=undefined;
      modal.dismiss('Cross click');
      this.sharedService.showSuccessKey("AdditionRequestDeletedSuccessfully");
      },
     
    );
  }
  additionRequestPreview(additionRequest,modal){
    this.editedAdditionRequest={};
    this.editedAdditionRequest= {...additionRequest};
    if(this.editedAdditionRequest.additionStatusId!=3){
      this.loadfromparent4.next({ "id": this.editedAdditionRequest.additionRequestId, "IsReadOnly": true });
   
    } 
      this.sharedService.get(`api/AdditionRequest/GetAttchments?AdditionRequestId=${this.editedAdditionRequest.additionRequestId}`).subscribe(res => {
          this.attachmentList = res;
          // this.sharedService.openLarge(modal);
      });
        this.sharedService.openLarge(modal);
  }
  editAdditionRequest(additionRequest){
    this.editedAdditionRequest={};
    this.editedAdditionRequest= {...additionRequest};
    this.loadfromparent3.next({ "id": additionRequest.additionRequestId, "IsReadOnly": false });
    // this.sharedService.openLarge(modal);
    this.showEditPage=true;
  }
  onEditAdditionRequest() {
    let obj=  {
     "additionRequestId": this.editedAdditionRequest.additionRequestId,
      "caseId": this.caseId,
      "title": this.editedAdditionRequest.title,
      "prosecutionId":this.editedAdditionRequest.prosecutionId,
      "description": this.editedAdditionRequest.description,
      "isDeleted": false,
    };
    this.sharedService.put(`api/AdditionRequest/Update`, [obj]).subscribe(res => {
      this.showEditPage=false;
      this.loadData();
      this.sharedService.showSuccessKey("EditedSuccessfully");
    });
  }

  ToLength(event){
    this.lengthAttach=event;
  }
  open(modal){
    this.sharedService.openSmall(modal);
  }
  isAcceptFun(isAccept:boolean){
    let obj={
      "additionRequestId": this.editedAdditionRequest.additionRequestId,
      "caseId": this.editedAdditionRequest.caseId,
      "isAccepted": isAccept,
      "isDeleted": false,
      "rejectReason" : this.editedAdditionRequest.rejectReason
    }
      this.sharedService.post(`api/AdditionRequest/AcceptReject`,obj).subscribe(res=>{
        this.loadData();
      //  isAccept ? this.sharedService.showSuccessKey('SentToTheProsecution') : this.sharedService.showSuccessKey('RequestHasBeenRejected');

          res && isAccept ? this.sharedService.showSuccessKey('SentToTheProsecution') :

              (res && !isAccept) ? this.sharedService.showSuccessKey('RequestHasBeenRejected') :
                  this.sharedService.showErrorKey('SomethingWentWrong')
              ;

          this.modalService.dismissAll();
      },err=>{
        this.modalService.dismissAll();
        this.sharedService.showErrorKey('SomethingWentWrong')
      })
  }
  sendAdditionRequest(isInAddModal){
    let requestId = isInAddModal? this.additionRequestId : this.editedAdditionRequest.additionRequestId;
    this.sharedService.get(`api/AdditionRequest/SendAddtionRequest?AdditionRequestId=${requestId}`).subscribe(res=>{
      this.sharedService.showSuccessKey("AdditionRequestSendSuccessfully");
      this.loadData();
      this.showAddPage=false;
      this.showEditPage=false;
    })
  }
  downloadFile(data: any, attachment: any) {
    var blob = new Blob([data], { type: attachment.mimeType });
    var url = window.URL.createObjectURL(blob);

    var fileLink = document.createElement('a');
    fileLink.href = url;
    fileLink.download = attachment.fileName;
    fileLink.click();
  }
  download(attachment) {
      let url = `api/Attachment/Download?eAttachmnetId=${attachment.eAttachmentId}`;
      this.sharedService.downloadFileGet(url).subscribe(data => {
          this.downloadFile(data, attachment);
      });
  }
  doc: any = "https://vadimdez.github.io/ng2-pdf-viewer/assets/pdf-test.pdf";
  pdfFile = false;
  image: any;
  previewPDF(attach, pdfmodal) {
    this.sharedService.openLarge(pdfmodal);
    this.show(attach);
  }
  show(attachment) {
    let url = `api/Attachment/Download?eAttachmnetId=${attachment.eAttachmentId}`;
    this.sharedService.downloadFileGet(url).subscribe(data => {
        this.ShowFile(data, attachment);
    });
}
  ShowFile(data: any, attachment: any) {
      var blob = new Blob([data], { type: attachment.fileType });
      var url = window.URL.createObjectURL(blob);
      this.doc = url;
      if (attachment.fileName.endsWith('.pdf')) {
          this.pdfFile = true;
      } else {
          this.pdfFile = false;
          this.image = this.sanitizer.bypassSecurityTrustUrl(url)
      }
  }

}
